module.exports = __webpack_public_path__ + "img/应用场景_智慧屏场景首图.0b519d97.png";